var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"card-full",class:{ 'has-detail': _vm.hasDetail }},_vm.hasDetail ? {click: _vm.detail} : null),[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"card-full__data"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }